<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "block_display_condition_action_label" | translate }}
                </label>
                <div class="col-xs-12">
                    <select class="form-control" (change)="setState($event)">
                        @for (option of stateOptions; track option) {
                            <option [selected]="state() === option" [value]="option">
                                {{ "block_display_condition_action_state_" + option | translate }}
                            </option>
                        }
                    </select>
                </div>
            </div>

            <div class="form-group mb-0">
                <div class="col-xs-12 condition-label-wrapper">
                    <label>
                        {{ "block_display_conditions_label" | translate }}
                    </label>

                    @if (conditions().length > 1) {
                        @if (operator() === EDisplayConditionOperator.AND) {
                            <div class="operator-marker">
                                <span class="small">{{
                                    "block_display_condition_operator_state_all" | translate
                                }}</span>
                                <div class="operator-icon" (click)="toggleOperatorValue(EDisplayConditionOperator.OR)">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="16"
                                        viewBox="0 0 25 16"
                                        fill="none"
                                    >
                                        <path
                                            opacity="0.4"
                                            d="M9 8C9 3.2 12.5 2 12.5 2C12.5 2 16 3.2 16 8C16 12.8 12.5 14 12.5 14C12.5 14 9 12.8 9 8Z"
                                            fill="#9DB5C4"
                                        />
                                        <circle cx="8" cy="8" r="7.5" stroke="#9DB5C4" />
                                        <circle cx="17" cy="8" r="7.5" stroke="#9DB5C4" />
                                    </svg>
                                </div>
                            </div>
                        }
                        @if (operator() === EDisplayConditionOperator.OR) {
                            <div class="operator-marker">
                                <span class="small">{{
                                    "block_display_condition_operator_state_any" | translate
                                }}</span>
                                <div class="operator-icon" (click)="toggleOperatorValue(EDisplayConditionOperator.AND)">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="16"
                                        viewBox="0 0 25 16"
                                        fill="none"
                                    >
                                        <circle
                                            cx="8"
                                            cy="8"
                                            r="7.5"
                                            fill="#9DB5C4"
                                            fill-opacity="0.5"
                                            stroke="#9DB5C4"
                                        />
                                        <circle
                                            cx="17"
                                            cy="8"
                                            r="7.5"
                                            fill="#9DB5C4"
                                            fill-opacity="0.5"
                                            stroke="#9DB5C4"
                                        />
                                        <path
                                            d="M10.0156 7.99219C10.0156 3.71094 12.5 2.64062 12.5 2.64062C12.5 2.64062 14.9844 3.71094 14.9844 7.99219C14.9844 12.2734 12.5 13.3438 12.5 13.3438C12.5 13.3438 10.0156 12.2734 10.0156 7.99219Z"
                                            fill="#C1D0D8"
                                        />
                                    </svg>
                                </div>
                            </div>
                        }
                    }
                </div>
            </div>

            @for (condition of conditions(); track condition; let i = $index) {
                <div class="well well-sm mb-5">
                    <web-condition-item-settings
                        [conditionItem]="condition"
                        [conditionItemIndex]="i"
                        [isCanRemove]="conditions().length > 1"
                        [maUserTimezone]="maUserTimezone$ | async"
                        (valueChangeEvent)="setBlockDisplayConditionItem($event, i)"
                        (removeConditionItemEvent)="removeConditionItem(i)"
                        (setOnlyAlwaysCondition)="setOnlyAlwaysCondition()"
                    />
                </div>
                @if (operator() && i !== conditions().length - 1) {
                    <div class="operator-divider">
                        @if (operator() === EDisplayConditionOperator.AND) {
                            <span class="small text-muted">{{
                                "block_display_condition_operator_and" | translate
                            }}</span>
                        }
                        @if (operator() === EDisplayConditionOperator.OR) {
                            <span class="small text-muted">{{
                                "block_display_condition_operator_or" | translate
                            }}</span>
                        }
                    </div>
                }
            }

            @if (conditions()[0]?.conditionType !== "always") {
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <a class="dotted" (click)="addConditionItem()">{{
                            "block_display_condition_add_button" | translate
                        }}</a>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
